import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0699 = React.lazy(() => import('./symbols/0699_user_profile_avatar_man_male'));
const Symbol0700 = React.lazy(() => import('./symbols/0700_user_profile_avatar_woman_female'));
const Symbol0701 = React.lazy(() => import('./symbols/0701_user_profile_avatar_man_male'));
const Symbol0702 = React.lazy(() => import('./symbols/0702_user_profile_avatar_woman_female'));
const Symbol0703 = React.lazy(() => import('./symbols/0703_users_profile_group_two'));
const Symbol0704 = React.lazy(() => import('./symbols/0704_users_profile_group_couple_man_woman'));
const Symbol0705 = React.lazy(
  () => import('./symbols/0705_user_profile_security_password_permissions')
);
const Symbol0706 = React.lazy(() => import('./symbols/0706_user_profile_add_new'));
const Symbol0707 = React.lazy(() => import('./symbols/0707_user_profile_remove_delete'));
const Symbol0708 = React.lazy(() => import('./symbols/0708_user_profile'));
const Symbol0709 = React.lazy(() => import('./symbols/0709_user_profile_avatar_man_male'));
const Symbol0710 = React.lazy(
  () => import('./symbols/0710_business_tie_user_profile_avatar_man_male')
);
const Symbol0711 = React.lazy(
  () => import('./symbols/0711_young_boy_user_profile_avatar_man_male')
);
const Symbol0712 = React.lazy(() => import('./symbols/0712_user_profile_avatar_girl_woman_female'));
const Symbol0713 = React.lazy(() => import('./symbols/0713_user_profile_back_tag'));
const Symbol0714 = React.lazy(() => import('./symbols/0714_identity_card_photo_user_profile'));
const Symbol0715 = React.lazy(
  () => import('./symbols/0715_contact_archive_identity_card_photo_user_profile')
);
const Symbol0716 = React.lazy(() => import('./symbols/0716_user_profile_add_new'));
const Symbol0717 = React.lazy(() => import('./symbols/0717_user_profile_remove_delete'));
const Symbol0718 = React.lazy(
  () => import('./symbols/0718_user_profile_successful_check_verified')
);
const Symbol0719 = React.lazy(() => import('./symbols/0719_group_users_circle'));
const Symbol0720 = React.lazy(() => import('./symbols/0720_user_location_position'));
const Symbol0721 = React.lazy(() => import('./symbols/0721_identity_card_photo_tag_user_profile'));
const Symbol0722 = React.lazy(() => import('./symbols/0722_profile_user_search_find'));
const Symbol0723 = React.lazy(() => import('./symbols/0723_nurse_medicine_hospital_doctor'));
const Symbol0724 = React.lazy(() => import('./symbols/0724_policeman_security'));
const Symbol0725 = React.lazy(() => import('./symbols/0725_fireman_fire'));
const Symbol0726 = React.lazy(() => import('./symbols/0726_doctor_surgery_hospital'));
const Symbol0727 = React.lazy(
  () => import('./symbols/0727_detective_criminal_sherlock_investigation')
);
const Symbol0728 = React.lazy(
  () => import('./symbols/0728_construction_worker_site_helmet_safety')
);
const Symbol0729 = React.lazy(
  () => import('./symbols/0729_student_degree_science_university_school_graduate')
);
const Symbol0730 = React.lazy(() => import('./symbols/0730_support_male_phone'));
const Symbol0731 = React.lazy(() => import('./symbols/0731_support_female_phone'));

export interface IProps {}

const Users: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0699_user_profile_avatar_man_male" symbol={<Symbol0699 />} />
      <LazySymbol id="0700_user_profile_avatar_woman_female" symbol={<Symbol0700 />} />
      <LazySymbol id="0701_user_profile_avatar_man_male" symbol={<Symbol0701 />} />
      <LazySymbol id="0702_user_profile_avatar_woman_female" symbol={<Symbol0702 />} />
      <LazySymbol id="0703_users_profile_group_two" symbol={<Symbol0703 />} />
      <LazySymbol id="0704_users_profile_group_couple_man_woman" symbol={<Symbol0704 />} />
      <LazySymbol id="0705_user_profile_security_password_permissions" symbol={<Symbol0705 />} />
      <LazySymbol id="0706_user_profile_add_new" symbol={<Symbol0706 />} />
      <LazySymbol id="0707_user_profile_remove_delete" symbol={<Symbol0707 />} />
      <LazySymbol id="0708_user_profile" symbol={<Symbol0708 />} />
      <LazySymbol id="0709_user_profile_avatar_man_male" symbol={<Symbol0709 />} />
      <LazySymbol id="0710_business_tie_user_profile_avatar_man_male" symbol={<Symbol0710 />} />
      <LazySymbol id="0711_young_boy_user_profile_avatar_man_male" symbol={<Symbol0711 />} />
      <LazySymbol id="0712_user_profile_avatar_girl_woman_female" symbol={<Symbol0712 />} />
      <LazySymbol id="0713_user_profile_back_tag" symbol={<Symbol0713 />} />
      <LazySymbol id="0714_identity_card_photo_user_profile" symbol={<Symbol0714 />} />
      <LazySymbol
        id="0715_contact_archive_identity_card_photo_user_profile"
        symbol={<Symbol0715 />}
      />
      <LazySymbol id="0716_user_profile_add_new" symbol={<Symbol0716 />} />
      <LazySymbol id="0717_user_profile_remove_delete" symbol={<Symbol0717 />} />
      <LazySymbol id="0718_user_profile_successful_check_verified" symbol={<Symbol0718 />} />
      <LazySymbol id="0719_group_users_circle" symbol={<Symbol0719 />} />
      <LazySymbol id="0720_user_location_position" symbol={<Symbol0720 />} />
      <LazySymbol id="0721_identity_card_photo_tag_user_profile" symbol={<Symbol0721 />} />
      <LazySymbol id="0722_profile_user_search_find" symbol={<Symbol0722 />} />
      <LazySymbol id="0723_nurse_medicine_hospital_doctor" symbol={<Symbol0723 />} />
      <LazySymbol id="0724_policeman_security" symbol={<Symbol0724 />} />
      <LazySymbol id="0725_fireman_fire" symbol={<Symbol0725 />} />
      <LazySymbol id="0726_doctor_surgery_hospital" symbol={<Symbol0726 />} />
      <LazySymbol id="0727_detective_criminal_sherlock_investigation" symbol={<Symbol0727 />} />
      <LazySymbol id="0728_construction_worker_site_helmet_safety" symbol={<Symbol0728 />} />
      <LazySymbol
        id="0729_student_degree_science_university_school_graduate"
        symbol={<Symbol0729 />}
      />
      <LazySymbol id="0730_support_male_phone" symbol={<Symbol0730 />} />
      <LazySymbol id="0731_support_female_phone" symbol={<Symbol0731 />} />
    </>
  );
});

Users.displayName = 'Users';

export default Users;
